module.exports = __webpack_public_path__ + "c1477876bc460d2c333a8878ed17df2c.pdf";